<template>
  <div class="flex h-screen flex-col">
    <div class="grow">
      <slot />
    </div>
    <UIFooter />
  </div>
</template>

<script lang="ts" setup>
import { useTenantAppearance } from '@booking-portal/composables/use-tenant-appearance';
import UIFooter from '@booking-portal/modules/ui/components/UIFooter.vue';
import { onMounted, watchEffect } from 'vue';

const { loadFonts, inlineStyles } = useTenantAppearance();

onMounted(() => {
  loadFonts();

  watchEffect(() => {
    document.body.setAttribute('style', inlineStyles.value);
  });
});
</script>

<style lang="scss"></style>
